require('lightgallery.js/lib/js/lightgallery');
require('lightgallery.js/lib/js/lg-utils');

export default class SimpleGallery {
  constructor(element) {
    this.element = element;
    this.mainImage = element.querySelector('.simple-gallery__main-visual img');
    this.thumbnails = [...element.querySelectorAll('.simple-gallery__thumbs-btn')];
    this.activeThumb = element.querySelector('.simple-gallery__thumbs-btn.active');
    this.init();
  }

  init() {
    this.initThumbs();
    this.initLightGallery();
  }

  initThumbs() {
    this.thumbnails.forEach(thumb => {
      const change = () => {
        this.activeThumb.classList.remove('active');
        this.activeThumb = thumb;
        thumb.classList.add('active');
        this.mainImage.src = thumb.dataset.highresSrc;
      };

      thumb.addEventListener('click', change);

      thumb.addEventListener('keydown', e => {
        if (e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          change();
        }
      });
    });
  }

  initLightGallery() {
    const trigger = document.querySelector('.js-lightgallery-trigger');

    if (trigger && window.galleryImages) {
      trigger.addEventListener('click', e => {
        e.preventDefault();

        const currentThumb = document.querySelector('.simple-gallery__thumbs-btn.active');
        const currentThumbIndex = parseInt(currentThumb.dataset.index, 10);

        // eslint-disable-next-line no-undef
        lightGallery(trigger, {
          index: currentThumbIndex,
          counter: false,
          download: false,
          dynamic: true,
          dynamicEl: window.galleryImages,
        });
      });
    }
  }
}
